module.exports = __webpack_public_path__ + "img/0a8ebc1.webp";